module.exports = __webpack_public_path__ + "img/report.43b6bd6d.svg";